export const LANG_MAP = {
  EN_NZ: 'en-NZ', // New Zealand English
  BR_PT: 'pt-BR', // Brazilian Portuguese
  BUL: 'bg-BG', // Bulgarian
  GWI: 'gwi-CA', // Gwich’in (припускаю Canada, бо це їх регіон)
  EN_ZA: 'en-ZA', // South African English
  KOR: 'ko-KR', // Korean
  ITA: 'it-IT', // Italian
  CZE: 'cs-CZ', // Czech
  UZB: 'uz-UZ', // Uzbek
  CA_FR: 'fr-CA', // Canadian French
  POL: 'pl-PL', // Polish
  RUS: 'ru-RU', // Russian
  GER: 'de-DE', // German
  SVK: 'sk-SK', // Slovak
  CHU: 'cv-RU', // Chuvash
  UKR: 'uk-UA', // Ukrainian
  POR: 'pt-PT', // Portuguese (Portugal)
  GRE: 'el-GR', // Greek
  SPA: 'es-ES', // Spanish (Castilian)
  LAM: 'lam-ZM', // Lamba (Zambia)
  CA_EN: 'en-CA', // Canadian English
  AZE: 'az-AZ', // Azerbaijani
  FRA: 'fr-FR', // French
  ENG: 'en-GB', // English (default)
  MX_ES: 'es-MX', // Mexican Spanish (якщо є у твоєму списку)
};
